/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const StudyPlanBuilderFragment = {
  StudyPlanBuilder: gql`
    fragment StudyPlanBuilderQuery on productBuilder_Entry {
      typeHandle
      wysiwygContent
      imageCarousel {
        url
        width
        height
        ... on images_Asset {
          altText
        }
      }
      productBuilder {
        ... on productBuilder_Category {
          productCouponOverride
          productBuilderTable {
            state
            productId
            courseType
            duration
            coupon
          }
        }
      }
    }
  `,
};
